import PropTypes from 'prop-types';
import {createUseStyles} from 'react-jss';
import {connect} from 'react-redux';
import Sections from '../../enums/Sections';
import getIsRoktBannerPaddingEnabledForCheckoutPage
from '../../v2/selectors/RoktSelectors/getIsRoktBannerPaddingEnabledForCheckoutPage';
import {getSections} from '../../v2/selectors/selectors';
import {isMobile} from '../../v2/selectors/DeviceSelectors';
import getCheckoutProgressStep from '../../v2/selectors/uiSelectors/getCheckoutProgressStep';
import RoktCheckoutPage from './RoktCheckoutPage';

const useStyles = createUseStyles({
  contentWrapper: {
    padding: props => props.isBannerPaddingEnabled && '12px 24px',
  },
});

export function RoktCheckoutBanner(props) {
  const classes = useStyles(props);
  
  if (!props.shouldRenderRoktCheckoutBanner) return null;
  
  return (
    <div id="rokt-checkout-banner" className={classes.contentWrapper}>
      <RoktCheckoutPage />
    </div>
  );
}

RoktCheckoutBanner.propTypes = {
  shouldRenderRoktCheckoutBanner: PropTypes.bool,
  isBannerPaddingEnabled: PropTypes.bool,
};

const mapStateToProps = (state, ownProps) => {
  const sections = getSections(state);
  const isPaymentStep = ownProps.step <= sections.length && sections[ownProps.step - 1] === Sections.PAYMENT;
  
  return {
    shouldRenderRoktCheckoutBanner: (isMobile(state))
      ? (isPaymentStep && ownProps.step === getCheckoutProgressStep(state))
      : (isPaymentStep),
    isBannerPaddingEnabled: getIsRoktBannerPaddingEnabledForCheckoutPage(state),
  };
};

export default connect(mapStateToProps)(RoktCheckoutBanner);
